export const firebaseConfig = {
  apiKey: "AIzaSyCcih3n_69ooSeDVvWo0VRX0U0olUp7Wx8",
  authDomain: "faveback.firebaseapp.com",
  projectId: "faveback",
  storageBucket: "faveback.firebasestorage.app",
  messagingSenderId: "21665241502",
  appId: "1:21665241502:web:2a8a20593ad5fb854dde8f",
  measurementId: "G-7JKK82HH4D",
};
